export default "__VITE_ASSET__D05Vnm_Q__"